// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

var overlay = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.position("fixed"),
      tl: {
        hd: BrowserStyle.top(BrowserStyle.px(0)),
        tl: {
          hd: BrowserStyle.right(BrowserStyle.px(0)),
          tl: {
            hd: BrowserStyle.left(BrowserStyle.px(0)),
            tl: {
              hd: BrowserStyle.bottom(BrowserStyle.px(0)),
              tl: {
                hd: Css.backgroundColor(BrowserStyle.rgba(0, 0, 0, 0.2)),
                tl: {
                  hd: BrowserStyle.zIndex(3),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var contents = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.vw(38.0)),
      tl: {
        hd: BrowserStyle.position("fixed"),
        tl: {
          hd: BrowserStyle.top(BrowserStyle.pct(50.0)),
          tl: {
            hd: BrowserStyle.left(BrowserStyle.pct(50.0)),
            tl: {
              hd: BrowserStyle.transform(BrowserStyle.translate(BrowserStyle.pct(-50.0), BrowserStyle.pct(-50.0))),
              tl: {
                hd: BrowserStyle.backgroundColor({
                      TAG: /* White */7,
                      _0: /* Light */2
                    }),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.rem(2.0)),
                    tl: {
                      hd: BrowserStyle.boxSizing("borderBox"),
                      tl: {
                        hd: BrowserStyle.zIndex(5),
                        tl: {
                          hd: BrowserStyle.mobileMedia({
                                hd: BrowserStyle.width(BrowserStyle.vw(95.0)),
                                tl: /* [] */0
                              }),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  overlay: overlay,
  contents: contents
};

var text = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: {
            hd: BrowserStyle.marginTop(BrowserStyle.rem(1.0)),
            tl: /* [] */0
          }
        }));

var Styles$1 = {
  text: text
};

function BrowserComponents_Modal$Legacy$Text(Props) {
  var className = Props.className;
  var text$1 = Props.text;
  return React.createElement(BrowserComponents_Text.make, {
              className: BrowserStyle.Utils.extendBaseStyle(text, className),
              children: text$1
            });
}

var $$Text = {
  Styles: Styles$1,
  make: BrowserComponents_Modal$Legacy$Text
};

var title = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
          hd: BrowserStyle.margin(BrowserStyle.px(0)),
          tl: {
            hd: BrowserStyle.color({
                  TAG: /* Blue */0,
                  _0: /* Darkest */0
                }),
            tl: /* [] */0
          }
        }));

var Styles$2 = {
  title: title
};

function BrowserComponents_Modal$Legacy$TitleText(Props) {
  var title$1 = Props.title;
  return React.createElement("h3", {
              className: title
            }, React.createElement(ReactUtils.S.make, {
                  children: title$1
                }));
}

var TitleText = {
  Styles: Styles$2,
  make: BrowserComponents_Modal$Legacy$TitleText
};

var title$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin(BrowserStyle.px(0)),
      tl: /* [] */0
    });

var star = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(1.125)),
      tl: {
        hd: BrowserStyle.display("inlineBlock"),
        tl: /* [] */0
      }
    });

var Styles$3 = {
  title: title$1,
  star: star
};

function BrowserComponents_Modal$Legacy$TitleStars(Props) {
  var starCount = Props.starCount;
  return React.createElement("div", {
              className: title$1
            }, Relude_Array.repeat(starCount, React.createElement(BrowserComponents_Icon.make, {
                      icon: {
                        TAG: /* Small */1,
                        _0: {
                          TAG: /* Shift */6,
                          _0: /* StarFilled */21
                        }
                      }
                    })));
}

var TitleStars = {
  Styles: Styles$3,
  make: BrowserComponents_Modal$Legacy$TitleStars
};

function BrowserComponents_Modal$Legacy(Props) {
  var children = Props.children;
  var className = Props.className;
  var overlayClassName = Props.overlayClassName;
  return DomUtils.usePortal(React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: BrowserStyle.Utils.extendBaseStyle(overlay, overlayClassName)
                    }), React.createElement(BrowserComponents_FlexColumn.make, {
                      className: BrowserStyle.Utils.extendBaseStyle(contents, className),
                      children: children
                    })));
}

var Legacy = {
  StyleTypes: undefined,
  Icon: undefined,
  Styles: Styles,
  $$Text: $$Text,
  TitleText: TitleText,
  TitleStars: TitleStars,
  make: BrowserComponents_Modal$Legacy
};

function card(widthConstraint) {
  return Curry._1(BrowserStyle.merge, {
              hd: typeof widthConstraint === "number" ? (
                  widthConstraint !== 0 ? Curry._1(BrowserStyle.style, {
                          hd: BrowserStyle.minWidth(BrowserStyle.rem(34.0)),
                          tl: /* [] */0
                        }) : Curry._1(BrowserStyle.style, {
                          hd: BrowserStyle.width(BrowserStyle.rem(34.0)),
                          tl: /* [] */0
                        })
                ) : Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.width(BrowserStyle.rem(widthConstraint._0)),
                      tl: /* [] */0
                    }),
              tl: {
                hd: Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.backgroundColor({
                            TAG: /* White */7,
                            _0: /* Light */2
                          }),
                      tl: {
                        hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
                        tl: {
                          hd: BrowserStyle.boxShadow(/* Small */1),
                          tl: {
                            hd: BrowserStyle.maxHeight(BrowserStyle.vh(90.0)),
                            tl: {
                              hd: BrowserStyle.maxWidth(BrowserStyle.vw(95.0)),
                              tl: {
                                hd: BrowserStyle.mobileMedia({
                                      hd: BrowserStyle.minWidth(BrowserStyle.vw(95.0)),
                                      tl: {
                                        hd: BrowserStyle.width(BrowserStyle.unset),
                                        tl: /* [] */0
                                      }
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }),
                tl: /* [] */0
              }
            });
}

var titleRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.medium),
        tl: {
          hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.large),
          tl: {
            hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.large),
            tl: {
              hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.large),
              tl: /* [] */0
            }
          }
        }
      }
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Semibold */1);
}

var title$2 = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), /* [] */0));

var contentContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.minHeight(BrowserStyle.zero),
      tl: {
        hd: BrowserStyle.overflowY(BrowserStyle.auto),
        tl: {
          hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.large),
          tl: {
            hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.large),
            tl: {
              hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.large),
              tl: {
                hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.small),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var buttonContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderTop(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.flexEnd),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                tl: /* [] */0
              }),
          tl: {
            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
            tl: /* [] */0
          }
        }
      }
    });

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexBasis(BrowserStyle.zero),
              tl: /* [] */0
            }
          }),
      tl: /* [] */0
    });

var Styles$4 = {
  card: card,
  titleRow: titleRow,
  title: title$2,
  contentContainer: contentContainer,
  buttonContainer: buttonContainer,
  button: button
};

function BrowserComponents_Modal$Message(Props) {
  var children = Props.children;
  var param = Props.primaryButton;
  var secondaryButton = Props.secondaryButton;
  var title$3 = Props.title;
  var titleIcon = Props.titleIcon;
  var $staropt$star = Props.widthConstraint;
  var primaryButtonOnClick = param.onClick;
  var widthConstraint = $staropt$star !== undefined ? $staropt$star : /* FixedWidth */0;
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: card(widthConstraint),
              children: null
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: titleRow,
                  children: null
                }, Relude_Option.fold(null, (function (icon) {
                        return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: icon
                                        },
                                        size: /* Medium */2
                                      }), React.createElement(BrowserComponents_Spacer.make, {
                                        size: /* Small */3
                                      }));
                      }), titleIcon), React.createElement(BrowserComponents_Text.make, {
                      className: title$2,
                      children: title$3
                    })), React.createElement(BrowserComponents_FlexColumn.make, {
                  className: contentContainer,
                  children: children
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  className: buttonContainer,
                  children: null
                }, Relude_Option.fold(null, (function (param) {
                        var onClick = param.onClick;
                        return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.make, {
                                        actionPriority: /* Secondary */1,
                                        className: button,
                                        disabled: param.disabled,
                                        onClick: (function (param) {
                                            return onClick;
                                          }),
                                        size: /* Small */0,
                                        title: param.title
                                      }), React.createElement(BrowserComponents_Spacer.make, {
                                        size: /* Small */3
                                      }));
                      }), secondaryButton), React.createElement(BrowserComponents_Button.make, {
                      actionPriority: /* Primary */0,
                      className: button,
                      disabled: param.disabled,
                      onClick: (function (param) {
                          return primaryButtonOnClick;
                        }),
                      size: /* Small */0,
                      title: param.title
                    })));
}

var Message = {
  Styles: Styles$4,
  make: BrowserComponents_Modal$Message
};

exports.Legacy = Legacy;
exports.Message = Message;
/* overlay Not a pure module */
